<template>
  <div
    ref="list"
    class="chat-list"
  >
    <div
      ref="content"
      class="chat-list__content"
    >
      <chat-cell
        v-if="defaultMessage"
        :condensed="isMobile"
        :message="defaultMessage"
        :author="defaultAuthor"
      />
      <chat-cell
        v-for="(item, index) in items"
        :key="index"
        :condensed="isMobile"
        v-bind="item"
      />
    </div>
  </div>
</template>

<script>
import ChatCell from './ChatCell';

export default {
  name: 'ChatList',
  components: {
    ChatCell,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    defaultMessage: {
      type: String,
      default: '',
    },
    defaultAuthor: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },

  },
  watch: {
    items: {
      handler() {
        this.$nextTick().then(() => {
          this.goToBottom();
        });
      },
    },
  },
  methods: {
    goToBottom() {
      this.$refs.list.scroll({
        top: this.$refs.content.offsetHeight,
        behavior: 'smooth', // 👈 Make it smooth!
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-list {
  // width: 100%;
  max-width: 380px;
  height: 205px;
  overflow: auto;
  z-index: 1001;

  &__content {
    color: white;
    min-height: 205px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: linear-gradient(rgba(white, 0), rgba(white, 1) 50%);
    background-clip: text;
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    background-attachment: fixed;
    background-size: 100% 250px;
    background-repeat: no-repeat;
  }
}
</style>
